import { useEffect, useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { OtpInput } from "reactjs-otp-input";
import { PiCaretLeftBold } from "react-icons/pi";
import LoadingButton from "../../common/loadingButton";
import { sendOtpHandler } from "../../../services/auth";
import {
  calculateTimeDifference,
  getCurrentTime,
} from "../../../utils/Functions";

const Otp = ({
  phoneNumber,
  setIsOtp,
  loginHandler,
  otp,
  setOtp,
  loading,
  setLoading,
}: any) => {
  const optNumber = localStorage.getItem("y_phone");
  const otpTime = localStorage.getItem("y_date");

  const [isStarted, setIsStarted] = useState(0);

  const handleChange = (otp: any) => setOtp(otp);

  const otpTimerHandler = () => {
    sendOtpHandler(phoneNumber);
    localStorage.setItem("y_date", getCurrentTime());
  };

  const handleLoginFunction = () => {
    setLoading(true);
    loginHandler(otp);
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    handleLoginFunction();
  };

  useEffect(() => {
    if (phoneNumber !== optNumber) {
      localStorage.setItem("y_phone", phoneNumber);
    }
  }, [phoneNumber]);

  useEffect(() => {
    if (!otpTime) otpTimerHandler();
  }, [otpTime]);

  useEffect(() => {
    if (otp.length === 6) {
      handleLoginFunction();
    }
  }, [otp.length]);

  const Completionist = () => (
    <button
      className="btn btn-outline btn-success btn-xs"
      onClick={() => {
        otpTimerHandler();
        setIsStarted(isStarted + 1);
      }}
    >
      ارسال مجدد کد
    </button>
  );

  //@ts-ignore
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (
      (otpTime && calculateTimeDifference(otpTime) === "00:00") ||
      completed
    ) {
      return <Completionist />;
    } else {
      return (
        <span className="text-xs">
          ارسال مجدد کد{" "}
          <strong>
            {otpTime
              ? calculateTimeDifference(otpTime)
              : `${zeroPad(minutes, 2)}:${zeroPad(seconds, 2)}`}
          </strong>
        </span>
      );
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      className="flex-1 w-full mt-10 flex flex-col justify-between"
    >
      <div className="w-full flex flex-col">
        <span className="label-text text-right w-full">
          کد فعال‌سازی پیامک شده
        </span>
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={6}
          separator=""
          // hasErrored
          isInputNum
          containerStyle={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "4px",
            direction: "ltr",
            marginTop: "8px",
          }}
          inputStyle={{
            background: "#E2E8F0",
            minWidth: "48px",
            height: "48px",
            textAlign: "center",
            borderRadius: "8px",
          }}
          errorStyle={{
            border: "1px solid red",
          }}
        />
        <div className="mt-3 flex items-center justify-between">
          <span
            onClick={() => setIsOtp(false)}
            className="w-fit text-blue-500 text-xs flex items-center cursor-pointer"
          >
            ورود با رمز عبور
            <PiCaretLeftBold size={13} className="mr-1" />
          </span>

          <Countdown
            date={Date.now() + 120000}
            renderer={renderer}
            key={isStarted}
          >
            <Completionist />
          </Countdown>
        </div>
      </div>

      <LoadingButton
        title="ورود"
        type="submit"
        disabled={loading || otp.length < 6}
        loading={loading}
      />
    </form>
  );
};

export default Otp;
